
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/edition/page/[page]",
      function () {
        return require("private-next-pages/[lang]/edition/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/edition/page/[page]"])
      });
    }
  